module.exports = __webpack_public_path__ + "img/Tastings.8a90c744.png";